import "core-js/modules/es.object.assign.js";
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from 'react';
import { Paragraph } from '@finect/tabular-core/Paragraph';
import { H5 } from '@finect/tabular-core/Headings';
import { Link } from 'react-router-dom';
import { ArrowRight } from '@finect/tabular-icons/arrowRight';
import { HelpCircle } from '@finect/tabular-icons/helpCircle';
import { TextButton } from '@finect/tabular-core/TextButton';
import { Modal, ModalTitle } from '../../../../Modal';
import { ModalHeaderWithIcon, ModalBodyBlock, Content } from './partials';
export var TipStory = function TipStory(_ref) {
  var onClose = _ref.onClose;
  var link = {
    href: 'https://www.finect.com/usuario/santiagobaron/articulos/alfa-beta-fondo-que-son',
    text: 'Saber más',
    withSPA: false
  };
  var linkProps = link.withSPA ? {
    as: Link,
    to: link.href
  } : {
    href: link.href,
    as: 'a'
  };
  return React.createElement(Modal, {
    widthSize: "medium",
    onClose: onClose
  }, React.createElement(ModalBodyBlock, null, React.createElement(ModalHeaderWithIcon, null, React.createElement(HelpCircle, {
    size: "42",
    strokeWidth: "1.5"
  }), React.createElement("div", null, React.createElement(ModalTitle, null, "Aprendiendo sobre alpha y beta"))), React.createElement(Content, null, React.createElement(H5, null, "Alpha"), React.createElement(Paragraph, null, "El alpha es un indicador que sirve para comparar un fondo respecto a su \xEDndice de referencia. Un alpha positivo indica que el producto ha obtenido una rentabilidad superior al mercado; mientras que un alpha negativo indica que el producto ha obtenido una rentabilidad inferior a la obtenida por el mercado."), React.createElement(H5, null, "Beta"), React.createElement(Paragraph, null, "La beta es un indicador que sirve para comparar la volatilidad de un fondo respecto a su \xEDndice de referencia."), React.createElement(Paragraph, null, "Un beta inferior a 1 indica que el producto tiene un riesgo inferior al mercado; mientras que un valor superior a 1 indica que el producto es m\xE1s arriesgado que el mercado."), link ? React.createElement(Paragraph, null, React.createElement(TextButton, _extends({}, linkProps, {
    secondary: true,
    inline: true,
    "data-fi-event": "story-link"
  }), link.text, React.createElement(ArrowRight, {
    size: "18"
  }))) : null)));
};